import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

export const ncarbSchedulingPathStart = 'Candidate|Scheduling|Scheduling|';
export const ncarbSchedulingSharedProperties: Pick<
	LocDef,
	'shared' | 'htmlAllowed' | 'feature' | 'portal'
> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSchedulingNcarbAuthorizationDetail,
	portal: 'SP',
};

export type SPCandidateHistorySchedulingNcarbExamAuthFormLocNames =
	| 'SPCandidateHistorySchedulingNcarbExamAuthExamField'
	| 'SPCandidateHistorySchedulingNcarbExamAuthEligibilityIdField'
	| 'SPCandidateHistorySchedulingNcarbExamAuthStartDateField'
	| 'SPCandidateHistorySchedulingNcarbExamAuthEndDateField'
	| 'SPCandidateHistorySchedulingNcarbExamAuthStartDateRequired'
	| 'SPCandidateHistorySchedulingNcarbExamAuthEndDateRequired'
	| 'SPCandidateHistorySchedulingNcarbExamAuthEndDateInvalid';

export const spCandidateHistorySchedulingNcarbExamAuthFormLocs: LocDefs<SPCandidateHistorySchedulingNcarbExamAuthFormLocNames> =
	{
		SPCandidateHistorySchedulingNcarbExamAuthExamField: {
			defaultValue: 'Exam',
			description: 'Label for the exam name field.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Exam Name Field`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthEligibilityIdField: {
			defaultValue: 'Eligibility ID Number',
			description: 'Label for the eligibility ID field.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Eligibility ID Field`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthStartDateField: {
			defaultValue: 'Start Date',
			description: 'Label for the start date field.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Start Date Field`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthEndDateField: {
			defaultValue: 'End Date',
			description: 'Label for the end date field.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|End Date Field`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthStartDateRequired: {
			defaultValue: 'Start date is required',
			description: 'Error message for the start date field.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|Start Date Required`,
			displayType: 'Error',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthEndDateRequired: {
			defaultValue: 'End date is required',
			description: 'Error message for the end date field.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|End Date Required`,
			displayType: 'Error',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthEndDateInvalid: {
			defaultValue: 'End date must be after start date',
			description: 'Error message for the end date field when it is before the start date.',
			displayPath: `${ncarbSchedulingPathStart}Exam Authorizations|End Date Invalid`,
			displayType: 'Error',
			...ncarbSchedulingSharedProperties,
		},
	};

export type SPCandidateHistorySchedulingNcarbExamAuthFormLocType =
	LocMap<SPCandidateHistorySchedulingNcarbExamAuthFormLocNames>;
